// extracted by mini-css-extract-plugin
export default {"Seleventh":"Seleventh_Seleventh__wyQQv","row_1":"Seleventh_row_1__wtjxF","img_1":"Seleventh_img_1__yBe--","img_2":"Seleventh_img_2__80rVb","img_3":"Seleventh_img_3__3SfbS"};